<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.29 12">
		<path d="M9.33,6.21l-4,4a.31.31,0,0,1-.45,0l-4-4a.31.31,0,0,1,0-.45l.19-.19a.32.32,0,0,1,.46,0L4.69,8.68V.32A.32.32,0,0,1,5,0h.27A.32.32,0,0,1,5.6.32V8.68L8.69,5.57a.33.33,0,0,1,.45,0l.19.19A.31.31,0,0,1,9.33,6.21Zm1,5.47v-.22a.33.33,0,0,0-.33-.32H.32a.32.32,0,0,0-.32.32v.22A.32.32,0,0,0,.32,12H10A.32.32,0,0,0,10.29,11.68Z"/>
	</svg>
</template>